import { set } from "cypress/types/lodash";
import React, { useState } from "react";
import { Axios } from "../../../services/axios";
import { UserTransactionDetails } from "../../../store/store";
import { useRecoilValue } from "recoil";
import { transactionDetails } from "../../../store";
import download from "downloadjs";
import { toast } from "react-toastify";
import hazard from "../../../assets/svg/Hazard.svg";
import check from "../../../assets/svg/Check.svg";

const QuoteManagerModal = ({
  onClose,
  downloadQuote,
  message = "",
  setMessage = (msg: string) => {},
}: {
  onClose: any;
  downloadQuote: () => void;
  message?: string;
  setMessage?: (message: string) => void;
}) => {
  const [activeTab, setActiveTab] = useState<"default" | "downloaded" | "email" | "sms">("default");
  const [emailInputs, setEmailInputs] = useState<string[]>([]);
  const [mobileNumbers, setMobileNumbers] = useState<string[]>([""]);
  const transactionData: UserTransactionDetails = useRecoilValue(transactionDetails);
  const [error, setError] = useState<boolean>(false);
  const [mobileErrors, setMobileErrors] = useState<string[]>([""]);
  const [emailErrors, setEmailErrors] = useState<string>("");
  const [emailVal, setEmailVal] = useState<string>("");
  const [disableAddMob, setDisableAddMob] = useState<boolean>(false);

  const handleQuoteSend = async () => {
    const vendorCode = JSON.parse(localStorage.getItem("vendorCode") || "{}");
    const userId = localStorage.getItem("userKey") || "";
    const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

    const purpose = transactionData?.transaction_purpose;
    const Money_you_send = transactionData?.conversion_amount?.toString();
    const Money_they_receive = transactionData?.reciepient_recieve?.toString();
    const Exchange_rate = transactionData?.conversion_rate?.toString();
    const destCurrency = transactionData?.dest_currency?.toString();

    const totalTaxes_charges =
      transactionData.total_tax +
      transactionData.nostro_charges +
      transactionData.nostro_charges_new +
      transactionData.hop_fees +
      transactionData.tcs;

    const youPay =
      parseFloat(Money_you_send || "0") + parseFloat(totalTaxes_charges?.toString() || "0");

    if (
      !Money_you_send ||
      !Money_they_receive ||
      !Exchange_rate ||
      !vendorCode?.userId ||
      !purpose
    ) {
      toast.error("TO DOWNLOAD QUOTE, FILL VENDORCODE AND PURPOSECODE");
      return;
    }

    const commonFields: {
      transVendorKey: any;
      destinationCurrency: string;
      conversionRate: number;
      recipientReceive: number;
      taxes: number;
      totalPay: number;
      purposeCode: string;
      userSend: number;
      tcs: number;
      bankFee: number;
      nostro: number;
      vendorFee: number;
      sendType: "default" | "downloaded" | "email" | "sms";
      mobiles?: string[];
      emailId?: string[];
    } = {
      transVendorKey: vendorCode.userId,
      destinationCurrency: destCurrency,
      conversionRate: parseFloat(Exchange_rate),
      recipientReceive: parseFloat(Money_they_receive),
      taxes: transactionData.total_tax,
      totalPay: youPay,
      purposeCode: purpose,
      userSend: parseFloat(Money_you_send),
      tcs: transactionData.tcs,
      bankFee: transactionData.nostro_charges,
      nostro: transactionData.nostro_charges_new,
      vendorFee: transactionData.hop_fees,
      sendType: activeTab,
    };

    if (activeTab === "sms") {
      commonFields.mobiles = mobileNumbers.filter((num) => /^\d{10}$/.test(num));
    } else if (activeTab === "email") {
      commonFields.emailId = emailInputs.filter((email) => email.trim() !== "");
    }

    const payload = {
      ...commonFields,
      // validationKey: crypto.randomUUID(), // use your real GUID logic here
    };

    try {
      const response = await Axios.post(`/remit/user/${userId}/sendQuotesLink`, payload, {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
      });

      if (response?.data?.success == true) {
        if (activeTab === "sms") {
          setMessage("Link to download your quotation has been texted successfully via SMS.");
        } else if (activeTab === "email") {
          setMessage("Link to download your quotation has been emailed successfully");
        }
        setTimeout(() => {
          setMessage("");
        }, 3000);
      } else {
        toast.error(`${response?.data?.error?.type || "Something went wrong."}`);
      }
    } catch (error: any) {
      if (error?.response?.data?.error) {
        // toast.error(`${error.response.data.error.type}`);
        setError(true);
        if (activeTab === "sms") {
          setMessage("The SMS with your quotation link failed to send.");
        } else if (activeTab === "email") {
          setMessage(`Failed to send email.Your email didn’t receive the quotation link.`);
        } else {
          setMessage(`${error.response.data.error.type}`);
        }
        setTimeout(() => {
          setMessage("");
        }, 3000);
      } else {
        toast.error("An unexpected error occurred.");
      }
    }
  };

  const handleDownload = () => {
    setActiveTab("downloaded");
    downloadQuote();
  };

  const handleSendEmail = () => {
    handleQuoteSend();
    setEmailInputs([]);
  };

  const handleChangeMobile = (val: string, index: number) => {
    setMobileNumbers((prev) => {
      const updated = [...prev];
      updated[index] = val;
      return updated;
    });

    setMobileErrors((prev) => {
      const updated = [...prev];
      if (!val) {
        updated[index] = "";
      } else if (val.length !== 10) {
        updated[index] = "Phone number must be 10 digits";
      } else {
        updated[index] = "";
      }
      return updated;
    });
  };

  const handleSendMobile = () => {
    const validNumbers = mobileNumbers.filter((num) => /^\d{10}$/.test(num));
    handleQuoteSend();
    setMobileNumbers([""]);
  };

  const handleAddMobileField = () => {
    setMobileNumbers((prev) => {
      if (prev.length >= 5) return prev; // don’t add more than 5
      return [...prev, ""];
    });
  };

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleRemoveEmail = (index: number) => {
    setEmailInputs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRemoveMobile = (index: number) => {
    setMobileNumbers((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddEmailField = () => {
    if (!emailRegex.test(emailVal)) {
      setEmailErrors("Please enter a valid email address");
    }
    setEmailInputs((prev) => {
      if (prev.length >= 5) return prev;
      return [...prev, emailVal];
    });
    setEmailVal("");
  };

  const MobileInputList = () => (
    <div className={`flex flex-col gap-y-4 mt-2 w-full`}>
      {mobileNumbers.map((num, index) => (
        <>
          <div key={index} className="flex flex-col gap-1">
            <div className={"flex gap-3 w-full items-center"}>
              <input
                type="number"
                placeholder="Enter mobile number"
                className="flex flex-1 border p-2 rounded-md justify-between items-center"
                defaultValue={mobileNumbers[index]}
                inputMode="numeric"
                maxLength={10}
                autoComplete="off"
                onChange={(e) => {
                  const val = e.target.value.trim();
                  if (!/^\d*$/.test(val)) return;

                  if (val.length == 10) {
                    handleChangeMobile(val, index);
                    setDisableAddMob(false);
                  }
                  // else if (val.length !== 10){
                  //     setDisableAddMob(true)
                  // }
                }}
              />

              {mobileNumbers.length > 1 && (
                <button
                  className="w-5 h-5 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200"
                  onClick={() => handleRemoveMobile(index)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="10"
                    height="10"
                    fill="none"
                    viewBox="0 0 16 16"
                    className="text-black"
                  >
                    <path
                      fill="currentColor"
                      fillRule="evenodd"
                      d="M8 6.586L13.657.929 15.071 2.343 9.414 8l5.657 5.657-1.414 1.414L8 9.414l-5.657 5.657-1.414-1.414L6.586 8 .929 2.343 2.343.929 8 6.586Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              )}
              {/* Show add button only on last field AND only if less than 5 fields */}
              {index === mobileNumbers.length - 1 && mobileNumbers.length < 5 && (
                <button
                  type="button"
                  onClick={handleAddMobileField}
                  className="bg-[#023496] text-white p-2 rounded-md disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer"
                  disabled={mobileErrors[index] != "" || disableAddMob}
                >
                  + Add
                </button>
              )}
            </div>
            {mobileErrors[index] ? (
              <p className="text-[#960202] text-xs font-normal pl-1">{mobileErrors[index]}</p>
            ) : (
              <p className="text-[#61758A] text-xs font-normal pl-1">Enter valid 10 digit number</p>
            )}
          </div>
        </>
      ))}
    </div>
  );

  return (
    <div className="fixed inset-0 z-[99] flex items-center justify-center bg-opacity-5 bg-black/50 w-full h-full">
      <div className="bg-white rounded-md w-[722px]">
        {/* Header */}
        <div className="bg-[#0F5BF1] py-3 pl-[282.5px] pr-[33px] rounded-t-md flex justify-between items-center">
          <h2 className="text-2xl font-sans text-white font-semibold">Quote Manager</h2>
          <button
            onClick={() => onClose()}
            className="hover:transform hover:scale-110 transition-transform"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="16"
              viewBox="0 0 17 16"
              fill="none"
            >
              <path
                d="M1.79297 1C3.47297 2.60934 11.8263 10.6113 15.793 14.4112"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
              <path
                d="M15.793 1C14.113 2.60934 5.75964 10.6113 1.79297 14.4112"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        {/* Content */}
        <div className="flex flex-col items-center justify-center gap-10 px-[33px] pt-[36px] pb-[138.57px]">
          <p className="font-sans text-xl font-semibold text-center self-stretch">Share quote</p>

          {/* Tabs */}
          <div className="flex justify-center gap-4">
            {/* Download */}
            <button
              onClick={handleDownload}
              className={`px-4 py-[9.75px] rounded-md flex gap-3 items-center border transition-colors
                            ${
                              activeTab === "downloaded"
                                ? "bg-black text-white"
                                : "bg-[#F1F4FF] text-[#282A30] hover:bg-black hover:text-white"
                            }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="15"
                viewBox="0 0 16 15"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.0714 9.53647V13.7868C15.0714 14.4574 14.5277 15.0011 13.8571 15.0011H1.71341C1.04273 15.0011 0.499043 14.4574 0.499043 13.7868V9.53647C0.499043 9.20113 0.770888 8.92929 1.10623 8.92929C1.44156 8.92929 1.71341 9.20113 1.71341 9.53647V13.7868H13.8571V9.53647C13.8571 9.20113 14.1289 8.92929 14.4642 8.92929C14.7996 8.92929 15.0714 9.20113 15.0714 9.53647ZM7.35565 9.96605C7.46954 10.0801 7.62408 10.1441 7.78524 10.1441C7.94639 10.1441 8.10093 10.0801 8.21482 9.96605L11.2507 6.93014C11.488 6.69289 11.488 6.30823 11.2507 6.07098C11.0135 5.83372 10.6288 5.83372 10.3916 6.07098L8.39242 8.07088V1.03591C8.39242 0.700576 8.12057 0.428731 7.78524 0.428731C7.4499 0.428731 7.17805 0.700576 7.17805 1.03591V8.07088L5.1789 6.07098C4.94165 5.83372 4.55699 5.83372 4.31974 6.07098C4.08249 6.30823 4.08249 6.69289 4.31974 6.93014L7.35565 9.96605Z"
                  fill="currentColor"
                />
              </svg>
              Download
            </button>

            {/* Mobile */}
            <button
              onClick={() => setActiveTab("sms")}
              className={`px-4 py-[9.75px] rounded-md flex gap-3 items-center border transition-colors
                            ${
                              activeTab === "sms"
                                ? "bg-black text-white"
                                : "bg-[#F1F4FF] text-[#282A30] hover:bg-black hover:text-white"
                            }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 21 21"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M11.6758 10.7148C11.6758 11.3362 11.1721 11.8398 10.5508 11.8398C9.92946 11.8398 9.42578 11.3362 9.42578 10.7148C9.42578 10.0935 9.92946 9.58984 10.5508 9.58984C11.1721 9.58984 11.6758 10.0935 11.6758 10.7148ZM6.42578 9.58984C5.80446 9.58984 5.30078 10.0935 5.30078 10.7148C5.30078 11.3362 5.80446 11.8398 6.42578 11.8398C7.0471 11.8398 7.55078 11.3362 7.55078 10.7148C7.55078 10.0935 7.0471 9.58984 6.42578 9.58984ZM14.6758 9.58984C14.0545 9.58984 13.5508 10.0935 13.5508 10.7148C13.5508 11.3362 14.0545 11.8398 14.6758 11.8398C15.2971 11.8398 15.8008 11.3362 15.8008 10.7148C15.8008 10.0935 15.2971 9.58984 14.6758 9.58984ZM20.3008 10.7148C20.3015 14.1389 18.5061 17.3124 15.5708 19.0753C12.6355 20.8383 8.99056 20.9323 5.96828 19.323L2.77609 20.387C2.23705 20.5668 1.64269 20.4265 1.24089 20.0247C0.839089 19.6229 0.698827 19.0286 0.878594 18.4895L1.94266 15.2973C0.0375214 11.7155 0.549523 7.32816 3.22825 4.28122C5.90697 1.23428 10.1925 0.164528 13.989 1.59517C17.7854 3.0258 20.2991 6.65782 20.3008 10.7148ZM18.8008 10.7148C18.7998 7.24638 16.6295 4.14892 13.3698 2.96376C10.1101 1.77859 6.45721 2.75883 4.22879 5.41672C2.00037 8.07461 1.67236 11.8425 3.40797 14.8455C3.51548 15.0315 3.53801 15.2548 3.46984 15.4586L2.30078 18.9648L5.80703 17.7958C5.8834 17.7697 5.96353 17.7564 6.04422 17.7564C6.17594 17.7566 6.30528 17.7916 6.41922 17.8577C8.97189 19.3346 12.1188 19.3366 14.6733 17.8629C17.2279 16.3892 18.8015 13.664 18.8008 10.7148Z"
                  fill="currentColor"
                />
              </svg>
              Mobile
            </button>

            {/* Email */}
            <button
              onClick={() => setActiveTab("email")}
              className={`px-4 py-[9.75px] rounded-md flex gap-3 items-center border transition-colors
                            ${
                              activeTab === "email"
                                ? "bg-black text-white"
                                : "bg-[#F1F4FF] text-[#282A30] hover:bg-black hover:text-white"
                            }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="16"
                viewBox="0 0 21 16"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M19.6016 0.214844H1.60156C1.18735 0.214844 0.851562 0.55063 0.851562 0.964844V13.7148C0.851562 14.5433 1.52314 15.2148 2.35156 15.2148H18.8516C19.68 15.2148 20.3516 14.5433 20.3516 13.7148V0.964844C20.3516 0.55063 20.0158 0.214844 19.6016 0.214844ZM10.6016 8.19766L3.53 1.71484H17.6731L10.6016 8.19766ZM7.85563 7.71484L2.35156 12.7595V2.67016L7.85563 7.71484ZM8.96562 8.73203L10.0906 9.76797C10.3775 10.0313 10.8181 10.0313 11.105 9.76797L12.23 8.73203L17.6675 13.7148H3.53L8.96562 8.73203ZM13.3475 7.71484L18.8516 2.66922V12.7605L13.3475 7.71484Z"
                  fill="currentColor"
                />
              </svg>
              Mail
            </button>
          </div>

          {/* Email Section */}
          {activeTab === "email" && (
            <>
              <div className={`flex flex-col gap-y-4 mt-2 w-full`}>
                <div className="flex flex-col gap-1">
                  {emailInputs.length <= 5 &&
                    emailInputs.map((email, index) => {
                      return (
                        <div className="flex flex-1 border p-2 rounded-md justify-between items-center">
                          {email}
                          <button
                            className="w-5 h-5 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200"
                            onClick={() => handleRemoveEmail(index)}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              fill="none"
                              viewBox="0 0 16 16"
                              className="text-black"
                            >
                              <path
                                fill="currentColor"
                                fillRule="evenodd"
                                d="M8 6.586L13.657.929 15.071 2.343 9.414 8l5.657 5.657-1.414 1.414L8 9.414l-5.657 5.657-1.414-1.414L6.586 8 .929 2.343 2.343.929 8 6.586Z"
                                clipRule="evenodd"
                              />
                            </svg>
                          </button>
                        </div>
                      );
                    })}
                  {emailInputs.length < 5 && (
                    <>
                      <div className={"flex gap-3 w-full items-center"}>
                        <input
                          type="email"
                          placeholder="Enter email address"
                          className="flex flex-1 border p-2 rounded-md justify-between items-center"
                          value={emailVal}
                          autoComplete="off"
                          onChange={(e) => {
                            const val = e.target.value;
                            setEmailVal(val);
                          }}
                        />
                        {emailInputs.length < 5 && (
                          <button
                            onClick={() => handleAddEmailField()}
                            className="bg-[#023496] text-white p-2 rounded-md disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer"
                            disabled={!emailRegex.test(emailVal)}
                          >
                            + Add
                          </button>
                        )}
                      </div>
                      <p className="text-xs text-red-100">
                        Please click the Add button to save the email before clicking the Send
                        button.
                      </p>
                      {emailErrors != "" && <p className="text-xs text-red-100">{emailErrors}</p>}
                    </>
                  )}
                </div>
              </div>
              <button
                onClick={handleSendEmail}
                disabled={emailErrors != "" || emailInputs.length == 0}
                className="w-full mt-4 bg-blue-600 text-white py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              >
                Send
              </button>
            </>
          )}

          {/* Mobile Section */}
          {activeTab === "sms" && (
            <>
              <MobileInputList />
              <button
                onClick={handleSendMobile}
                disabled={
                  // Case 1: all empty
                  mobileNumbers.every((m) => m.trim() === "") ||
                  // Case 2: at least one input < 10 digits (but not empty)
                  mobileNumbers.some((m) => m.trim() == "" && m.trim().length < 10) ||
                  // Case 3: errors array has something
                  mobileErrors.some((err) => err && err.trim() !== "")
                }
                className="w-full mt-4 bg-blue-600 text-white py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
              >
                Send
              </button>
            </>
          )}

          {/* Message Confirmation */}
          {message && (
            <div
              className={`p-2 rounded text-sm flex items-center text-center ${
                error ? "bg-[#FCE3E3] text-[#000]" : "bg-[#E3FCEF] text-[#000]"
              }`}
            >
              {error ? <img src={hazard} className="pr-2" /> : <img src={check} className="pr-2" />}
              {<span>{message}</span>}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuoteManagerModal;
